import React from 'react';
import { BookOpenIcon, FlaskConicalIcon } from 'lucide-react';
import { Section } from './Shared';
import { Blossom } from './FloralDecor';
import { FlowerMapCard } from './FlowerMapCard';
type Tome = {
  label: string;
  title: string;
  subtitle: string;
  icon: React.ElementType;
  cover: string;
  coverAlt: string;
  features: string[];
};
const tomes: Tome[] = [{
  label: 'TOMO I',
  title: 'El Manual de Intervención de Campo',
  subtitle: 'Protocolos de respuesta inmediata para crisis en consulta',
  icon: BookOpenIcon,
  cover: 'https://cdn.magicpatterns.com/uploads/r5ShgTL2jgZLwhnVjTdFdh/ChatGPT_Image_25_ago_2026,_14_30_49.png',
  coverAlt: 'Portada del Tomo I: El Manual de Intervención de Campo, Botiquín Bach',
  features: ['Los 5 signos de alerta que identifican una crisis en los primeros 60 segundos', 'Protocolo Rojo: cómo intervenir en pánico agudo (5-10 minutos)', 'Protocolo Azul: manejo de angustia profunda y duelo (15-20 minutos)', 'Protocolo Negro: control de descontrol y brotes de rabia (5-10 minutos)', 'El código de los 60 segundos: lectura de lenguaje corporal en crisis', 'Sistema de goteo acelerado: dosificación correcta en emergencias', 'Qué decir (y qué NO decir) al paciente en cada momento', 'Casos de estudio reales: protocolo paso a paso', '50 páginas de contenido tácticamente organizado']
}, {
  label: 'TOMO II',
  title: 'Las 15 Fórmulas Maestras “Copy-Paste”',
  subtitle: 'El recetario exacto: cada fórmula lista para aplicar',
  icon: FlaskConicalIcon,
  cover: 'https://cdn.magicpatterns.com/uploads/4tU1dJ7XrjNuTQ7YiQmhVt/ChatGPT_Image_25_ago_2026,_14_40_41.png',
  coverAlt: 'Portada del Tomo II: Las 15 Fórmulas Maestras, Botiquín Bach',
  features: ['Fórmulas #1-5: las 5 de emergencia inmediata (pánico, angustia, descontrol, disociación, shock)', 'Fórmulas #6-10: combinaciones tácticas para crisis complejas', 'Fórmulas #11-15: cierres, protección y recuperación del terapeuta', 'Cada fórmula incluye composición exacta, método, frecuencia, duración y señales de éxito', 'Variantes por intensidad de crisis (leve, moderada, severa)', 'Método del vaso de agua: la técnica que acelera la absorción 3x', 'Combinación tópica + oral: protocolo ultra-potente para crisis severas', '50 páginas de recetas precisas, sin teoría innecesaria']
}];
const bonuses = [{
  number: '01',
  title: 'Placa Visual de Emergencia',
  pages: '10 páginas',
  cover: 'https://cdn.magicpatterns.com/uploads/4r9WGjPviP5wSqVNkHhxjX/Captura_de_pantalla_2026-08-25_155247.png'
}, {
  number: '02',
  title: 'Guía de Bach Tópico',
  pages: '15 páginas',
  cover: 'https://cdn.magicpatterns.com/uploads/x9M2ykLNLoQkJgwu7Po3uJ/ChatGPT_Image_25_ago_2026,_14_51_13.png'
}, {
  number: '03',
  title: 'Ficha de Registro de Crisis',
  pages: '15 páginas',
  cover: 'https://cdn.magicpatterns.com/uploads/waxK5m9rPTsHJ414zngBGW/Captura_de_pantalla_2026-08-25_155315.png'
}, {
  number: '04',
  title: 'El Escudo del Terapeuta',
  pages: '20 páginas',
  cover: 'https://cdn.magicpatterns.com/uploads/4gJhTbKJmSEuHqHdh1oYqc/ChatGPT_Image_25_ago_2026,_14_59_11_(1).png'
}, {
  number: '05',
  title: 'Masterclass: El Negocio',
  pages: '20 páginas',
  cover: 'https://cdn.magicpatterns.com/uploads/bxV4saXi7me9FPygSU7TMG/ChatGPT_Image_25_ago_2026,_14_59_20.png'
}];
export function PackContents() {
  return <Section id="contenido" className="relative" data-id="element-236" data-mp="2h1o516m5nob9">
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 -z-10 overflow-hidden" data-id="element-237" data-mp="2c7tebj84u92o">
        <Blossom className="absolute right-[4%] top-10 h-24 w-24 text-brand-roseMist" data-id="element-238" data-mp="278qmj0h5xzcn" />
        <Blossom className="absolute left-[3%] top-1/2 h-20 w-20 text-brand-lavenderMist" data-id="element-239" data-mp="34pfhqbbly3d2" />
      </div>

      <div className="mb-4 text-center" data-id="element-240" data-mp="2zy7c7qdef256">
        <p className="mb-2 text-sm font-bold uppercase tracking-[.18em] text-brand-goldDark" data-id="element-241" data-mp="2zwcm7xn9sju8">✨ Todos los niveles</p>
        <h2 className="font-display text-3xl font-bold text-brand-green md:text-5xl" data-id="element-242" data-mp="2kisd2719c5ws">
          2 Tomos Principales + 5 Bonus Estratégicos
        </h2>
        <p className="mt-3 font-serif text-lg font-bold text-brand-rose md:text-2xl" data-id="element-243" data-mp="2ajjpbvwzjniv">
          🌸 + Nuevo Mapa Rápido de las 38 Flores de Bach™
        </p>
        <p className="mt-3 text-base text-brand-muted md:text-lg" data-id="element-244" data-mp="33776f0z1rw0r">
          Más de 150 páginas + herramientas visuales de consulta — Todo lo que necesitás, organizado y listo para usar.
        </p>
      </div>

      <p className="mx-auto mb-10 max-w-2xl text-center text-sm leading-relaxed text-brand-textLight md:text-base" data-id="element-245" data-mp="2thnlzqvoru3s">
        Ya sea que estés comenzando con Flores de Bach o que ya atiendas pacientes y quieras hacerlo con más criterio,
        seguridad y estructura profesional, <strong className="text-brand-greenMid" data-id="element-246" data-mp="3m3yjutrwrgww">el Botiquín Bach fue creado para vos</strong>.
      </p>

      <div className="mx-auto grid max-w-6xl gap-6 lg:grid-cols-2" data-id="element-247" data-mp="1fhj4p34v2vg7">
        {tomes.map(tome => {
        const Icon = tome.icon;
        return <article key={tome.label} className="paper-panel flex h-full flex-col rounded-3xl p-6 md:p-8" data-id="element-248" data-mp="1ahn0p3w5z40n">
              <div className="mb-5 flex flex-col gap-5 sm:flex-row sm:items-start" data-id="element-249" data-mp="1p6sxymbfyk5w">
                <div className="mx-auto w-36 shrink-0 sm:mx-0 sm:w-40" data-id="element-250" data-mp="1k9kcabr33xzw">
                  <div className="overflow-hidden rounded-xl border border-brand-green/15 bg-white shadow-[0_10px_24px_rgba(14,42,30,.14)]" data-id="element-251" data-mp="wi578b7xb2ky">
                    <img src={tome.cover} alt={tome.coverAlt} loading="lazy" className="block h-auto w-full" draggable={false} data-id="element-252" data-mp="rl52q4qq27vy" />
                  </div>
                </div>
                <div className="min-w-0 flex-1" data-id="element-253" data-mp="2gwp0eeo81bp2">
                  <div className="mb-2 flex items-center gap-2" data-id="element-254" data-mp="2cxg698p9rbsz">
                    <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-brand-green text-brand-goldLight ring-1 ring-brand-gold/40" data-id="element-255" data-mp="2cz9f8uncu845">
                      <Icon className="h-4 w-4" data-id="element-256" data-mp="1ejsqn6xfuhti" />
                    </span>
                    <p className="text-[11px] font-bold tracking-[.18em] text-brand-goldDark" data-id="element-257" data-mp="1jjxa95tn7sny">{tome.label}</p>
                  </div>
                  <h3 className="font-serif text-xl font-bold leading-tight text-brand-green md:text-2xl" data-id="element-258" data-mp="1nl8sgqa6tbm4">
                    {tome.title}
                  </h3>
                  <p className="mt-1.5 text-xs italic leading-snug text-brand-muted md:text-sm" data-id="element-259" data-mp="vu2vgiprju12">{tome.subtitle}</p>
                  <div className="leaf-rule mt-4" aria-hidden="true" data-id="element-260" data-mp="zv4zdcumku9d" />
                </div>
              </div>
              <ul className="space-y-2.5 text-sm leading-snug text-brand-text" data-id="element-261" data-mp="14npr88tz0xa9">
                {tome.features.map(feature => <li key={feature} className="flex gap-2.5" data-id="element-262" data-mp="82xh67zh19sv">
                    <span className="font-bold text-brand-greenMid" data-id="element-263" data-mp="c5aoh0tv9frr">✓</span>
                    <span data-id="element-264" data-mp="4ncih6aw8mta">{feature}</span>
                  </li>)}
              </ul>
            </article>;
      })}
      </div>

      <div className="mb-6 mt-14 text-center" data-id="element-265" data-mp="3vrawiavagn0p">
        <h3 className="font-serif text-xl font-bold text-brand-green md:text-2xl" data-id="element-266" data-mp="3rr0rb0fbm0mw">
          🎁 5 BONUS ESTRATÉGICOS — <span className="text-brand-goldDark" data-id="element-267" data-mp="3mrnwnti7jp9r">SIEMPRE INCLUIDOS</span>
        </h3>
      </div>

      <div className="mx-auto grid max-w-5xl grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-5" data-id="element-268" data-mp="3hunzy978zyvb">
        {bonuses.map(bonus => <article key={bonus.number} className="flex flex-col overflow-hidden rounded-2xl border border-brand-green/20 bg-brand-parchment text-center" data-id="element-269" data-mp="3d1l39s76c9aw">
            <div className="relative aspect-[5/7] w-full overflow-hidden bg-white" data-id="element-270" data-mp="343snkmxjizmz">
              <img src={bonus.cover} alt={`Portada del Bonus ${bonus.number}: ${bonus.title}`} loading="lazy" className="h-full w-full object-cover object-top" draggable={false} data-id="element-271" data-mp="2z23db9i56pzy" />
              <span className="absolute left-2 top-2 rounded-full bg-brand-green px-2.5 py-1 text-[9px] font-bold tracking-wide text-brand-goldLight" data-id="element-272" data-mp="quyfq1bmdhvf">
                BONUS {bonus.number}
              </span>
            </div>
            <div className="flex flex-1 flex-col p-3" data-id="element-273" data-mp="hsfgdr71lndx">
              <p className="text-[13px] font-bold leading-tight text-brand-text" data-id="element-274" data-mp="34uaxqmp3c2u">{bonus.title}</p>
              <p className="mt-auto pt-2 text-[11px] font-semibold text-brand-goldDark" data-id="element-275" data-mp="7vkj1bmi9t18">{bonus.pages}</p>
            </div>
          </article>)}
      </div>

      <FlowerMapCard data-id="element-276" data-mp="3qbemdmdx02r8" />

      <div className="mt-8 text-center" data-id="element-277" data-mp="3q7qsgm4k5ebz">
        <p className="inline-block rounded-full border border-brand-gold/60 bg-white px-5 py-3 text-sm font-medium text-brand-text" data-id="element-278" data-mp="3uadlgqcyt5ar">
          Todo el valor de los bonus + el nuevo recurso{' '}
          <span className="font-bold text-brand-greenMid" data-id="element-279" data-mp="3laqn6dfj8flx">incluido con tu Botiquín Bach</span>
        </p>
      </div>
    </Section>;
}